// Cart utilities using localStorage

export const cartStorage = {
  getCart: () => {
    const cart = localStorage.getItem('cheat_cart');
    return cart ? JSON.parse(cart) : [];
  },
  
  saveCart: (cart) => {
    localStorage.setItem('cheat_cart', JSON.stringify(cart));
  },
  
  clearCart: () => {
    localStorage.removeItem('cheat_cart');
  },
  
  addItem: (item) => {
    // Limpa carrinho e adiciona só o novo item (1 produto por vez)
    cartStorage.saveCart([item]);
  },
  
  removeItem: (index) => {
    const cart = cartStorage.getCart();
    cart.splice(index, 1);
    cartStorage.saveCart(cart);
  }
};

export const feedbacks = [
  {
    id: '1',
    username: 'Trilha_16y',
    date: '26/09/2025',
    message: 'painelzinho bom até pq ele é barato mais é bem completo da de fazer mt boyah etc',
    rating: 5,
    image: 'https://customer-assets.emergentagent.com/job_cheatforge/artifacts/0932ii3o_image.png'
  },
  {
    id: '2',
    username: 'deivin',
    date: '19/09/2025',
    message: 'o brabo atendeu super rápido e direto ao ponto sem erro',
    rating: 5,
    image: 'https://customer-assets.emergentagent.com/job_cheatforge/artifacts/4j39c3ce_image.png'
  },
  {
    id: '3',
    username: 'NAGATO',
    date: '19/09/2025',
    message: 'nossa ta pica o painel parabens',
    rating: 5
  },
  {
    id: '4',
    username: '[VND] SKILL',
    date: '23/09/2025',
    message: 'muito bom recomendo demaiaassss',
    rating: 5
  },
  {
    id: '5',
    username: 'Gigi 07',
    date: '23/09/2025',
    message: 'Suporte mt bom, tive um problema com mal funcionamento do painel e o suporte resolveu na hora e foi bem atencioso',
    rating: 5
  },
  {
    id: '6',
    username: 'Cliente Satisfeito',
    date: '23/09/2025',
    message: 'Esse com certeza entrou para meus top 10 feedbacks já feitos',
    rating: 5,
    image: 'https://customer-assets.emergentagent.com/job_cheatforge/artifacts/ewemmzqr_Captura%20de%20tela%202025-09-23%20170702.png'
  },
  {
    id: '7',
    username: 'O...',
    date: '27/09/2025',
    message: 'Painel top rapaziada, suporte 100% atencioso, confiável pra krai kkkk, o melhor do cenário',
    rating: 5
  },
  {
    id: '8',
    username: 'Ds',
    date: '28/09/2025',
    message: 'Painel muito bom rpzd suporte bom muito confiavel tmj',
    rating: 5
  },
  {
    id: '9',
    username: './destilado$',
    date: '15/03/2026',
    message: 'TOP DEMAIS, MELHOR PAINEL QUE JA USEI HIHI - MELHOR SUPORTE DO UNIVERSO',
    rating: 5,
    image: 'https://customer-assets.emergentagent.com/job_07e3fa1c-accb-40af-b9f6-b18f873b4bec/artifacts/lhc481xi_Captura%20de%20tela%202026-04-22%20000934.png'
  },
  {
    id: '10',
    username: 'silva',
    date: '13/04/2026',
    message: 'ta muito bom. Tu é foda mam',
    rating: 5,
    image: 'https://customer-assets.emergentagent.com/job_07e3fa1c-accb-40af-b9f6-b18f873b4bec/artifacts/e882yfay_Captura%20de%20tela%202026-04-22%20000905.png'
  },
  {
    id: '11',
    username: 'fly',
    date: '18/04/2026',
    message: 'top dms tem ate fov e tudo fora o preco bom So acho que DEVIA TER COMO MUDAR COR DO FOV',
    rating: 5,
    image: 'https://customer-assets.emergentagent.com/job_07e3fa1c-accb-40af-b9f6-b18f873b4bec/artifacts/ysvzl6g1_Captura%20de%20tela%202026-04-22%20000847.png'
  },
  {
    id: '12',
    username: 'vivo de win',
    date: '18/04/2026',
    message: 'PAPO RETO, QUE SERVIDOR PIKA, COMPREM SEM MEDO',
    rating: 5,
    image: 'https://customer-assets.emergentagent.com/job_07e3fa1c-accb-40af-b9f6-b18f873b4bec/artifacts/ei7cfxfi_Captura%20de%20tela%202026-04-22%20000843.png'
  },
  {
    id: '13',
    username: 'xisz',
    date: '16/04/2026',
    message: 'Mestre no ranqueado, vitórias seguidas no CS Ranqueado. Painel top demais!',
    rating: 5,
    image: 'https://customer-assets.emergentagent.com/job_07e3fa1c-accb-40af-b9f6-b18f873b4bec/artifacts/qs4yfw3g_Captura%20de%20tela%202026-04-22%20000859.png'
  }
];
